import { render } from "./QuienesSomos.vue?vue&type=template&id=8b42bd66"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=8b42bd66&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__